module.exports = __webpack_public_path__ + "img/81.5cea480c.png";